<template>
  <div v-if="isLoaded" class="container-fluid">
    <div v-if="currentCustomer && currentCustomer.id">
      <div class="row text-center mb-5">
        <div class="col-12 title-home-permalink">{{ clinicName }}</div>
        <div class="col-12 title-home-permalink">WEB予約</div>
      </div>
      <div class="row pt-5">
        <span class="col-xs-12 col-sm-6 col-sm-offset-3 next-step scroll-top mb-5" @click="emitShowChooseCategory">予約に進む</span>
        <a class="col-xs-12 col-sm-6 col-sm-offset-3 back-step scroll-top btn-booking-rounded" :href="bookingsPath">予約確認・変更・キャンセル</a>
      </div>
    </div>
    <div v-else>
      <div v-if="shouldShowCustomHtml">
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-sm-offset-3" v-html="customizedHtml"></div>
        </div>
      </div>
      <div v-else>
        <div class="row text-center mb-5">
          <div class="col-12 title-home-permalink">{{ clinicName }}</div>
          <div class="col-12 title-home-permalink">WEB予約</div>
        </div>
        <div class="row pt-5">
          <span class="col-xs-12 col-sm-6 col-sm-offset-3 next-step scroll-top mb-5" @click="emitShowChooseCategory">初回予約の方はこちら</span>
          <a class="col-xs-12 col-sm-6 col-sm-offset-3 back-step scroll-top btn-booking-rounded" :href="sessionsV2Path">2回目以降の方はこちら（ログイン）</a>
        </div>
        <div class="row mt-4 text-center description-home-permalink font-family-W3">
          <div>以前予約されたことがある方</div>
          <div>または</div>
          <div>予約の確認・キャンセルされたい方はログインしてください</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "HomePermalinkDefault",
  data() {
    return {
      bookingsPath: '/bookings',
      isLoaded: false
    };
  },
  computed: {
    ...mapGetters('permalink', ['currentCustomer', 'clinicName', 'permalinkData']),
    sessionsV2Path() {
      const callbackUrl = encodeURIComponent(this.$route.fullPath);
      return `/customers/v2/sign_in?callback_url=${callbackUrl}`;
    },
    shouldShowCustomHtml() {
      return this.permalinkData?.permalink?.web_page_customize_flag === true &&
        this.permalinkData?.permalink?.web_page_customize_html;
    },
    customizedHtml() {
      if (this.shouldShowCustomHtml) {
        return this.permalinkData.permalink.web_page_customize_html
          .replace("{{clinic_name}}", this.clinicName)
          .replace("{{permalink_href}}", this.sessionsV2Path)
          .replace("{{booking_href}}", "#")
      }
      return '';
    }
  },
  watch: {
    currentCustomer() {
      this.isLoaded = true;
    }
  },
  mounted() {
    if (this.currentCustomer) {
      this.isLoaded = true;
    }
    this.addCustomEventListeners();
  },
  updated() {
    this.addCustomEventListeners();
  },
  methods: {
    emitShowChooseCategory(event) {
      event.preventDefault();
      this.$emit('showChooseCategory');
    },
    addCustomEventListeners() {
      const customBookingLink = document.getElementById('{{booking_id}}');
      if (customBookingLink) {
        customBookingLink.addEventListener('click', this.emitShowChooseCategory);
      }
    }
  }
};
</script>

<style scoped>
</style>
